<template>
  <div style="background: #F2F6FC;">
    <MyBanner />
    <div>
      <div class="w1200">
        <div class="title">
          <div class="AnnouncementDetails">
            <el-breadcrumb :separator-icon="ArrowRight">
              <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/recruitmentAnnouncement' }">招募公告</el-breadcrumb-item>
              <el-breadcrumb-item>内容详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="join" @click="joinLogin">立即报名</div>
        </div>
        <div class="content">
          <div class="content-tip">
            <div class="bt">{{itemVlue.bulletinName}}</div>
            <div class="announcement-flex">
              <div class="flex">
                <div class="title-box">项目类别：</div>
                <div class="content-box">{{detailData(router.currentRoute.value.query.aicId)}}</div>
              </div>
              <div class="flex" style="margin-left: 80px;" v-if="itemVlue.bulletinEndTime!=null">
                <div class="title-box">公告截止时间：</div>
                <div class="content-box">{{itemVlue.bulletinEndTime?itemVlue.bulletinEndTime.slice(0,11):''}}</div>
              </div>
              <div class="flex">
                <div class="title-box">公告发布时间：</div>
                <div class="content-box">{{itemVlue.publishTime?itemVlue.publishTime.slice(0,11):''}}</div>
              </div>
            </div>
          </div>
          <!-- <div style="font-size: 14px;font-weight:500;color: rgba(0, 95, 46, 1);text-align: left;margin-top: 20px;margin-bottom: 10px;">详情介绍：</div> -->
          <div class="content-message" v-html="itemVlue.content" v-if="itemVlue.content != ''"></div>
          <div class="content-message" style="text-align: center;line-height: 100px;color: gray;" v-else>暂无详情</div>
        </div>
      </div>
      <MyFooter />
      <MyRight />
    </div>
  </div>
</template>
<script setup>
import MyBanner from "@/components/MyBanner.vue";
import MyRight from "@/components/RightFixd.vue";
import MyFooter from "@/components/MyFooter.vue";
import { ArrowRight } from '@element-plus/icons-vue'
import { loginTree } from '@/api/index.js'
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
let router = useRouter()
let loginTreeArr = ref('')
let Factive = ref('')
let itemVlue = ref({})
let detailData = (aicId) => {
  if (aicId == '1601040533446800') {
    return '货物'
  } else if (aicId == '1601040533446700') {
    return '工程'
  } else if (aicId == '1601040533446900') {
    return '服务'
  }
}
let joinLogin = () => {
  loginTreeArr.value.forEach(item => {
    if (item.dictValue == '用户登录入口') {
      window.open(item.dictKey, '_blank')
    }
  })
}
onMounted(async () => {
  Factive.value = router.currentRoute.value.query.title ? router.currentRoute.value.query.title : '平台公告'
  itemVlue.value = JSON.parse(router.currentRoute.value.query.ids)
  await detailData()
  await loginTree().then(res => {
    loginTreeArr.value = res.data
  })
})
</script>
<style scoped>
::v-deep .el-tabs__item {
  font-size: 18px;
  color: rgba(0, 117, 194, 1);
}
::v-deep .el-tabs__active-bar {
  background-color: rgba(0, 117, 194, 1);
}
::v-deep .el-table th.el-table__cell {
  background: rgba(243, 245, 247, 1);
  font-size: 14px;
  font-weight: 400;
  color: rgb(79, 84, 112);
}
.w1200 {
  width: 1300px;
  margin: 0 auto;
}
.content-message {
  min-height: 100px;
  border-radius: 5px;
  /* background: rgb(255, 255, 255); */
  /* border: 1px solid rgb(215, 215, 215); */
  color: #344;
  padding: 0 20px;
  box-sizing: border-box;
  line-height: 1.8;
  font-size: 16px;
  margin-top: 10px;
}
.bt {
  font-size: 28px;
  font-weight: 700;
  color: #444;
  width: 100%;
  padding-bottom: 10px;
  /* border-bottom: 1px solid #e4e0e0; */
  text-align: center;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0 15px 0;
}
.AnnouncementDetails {
  font-size: 22px;
  color: rgb(0, 0, 0);
  display: flex;
  align-items: flex-end;
}
.join {
  width: 100px;
  height: 36px;
  border-radius: 4px;
  background: linear-gradient(
      180deg,
      rgba(0, 95, 46, 1) 0%,
      rgba(49, 133, 58, 1) 100%
    ),
    rgba(204, 204, 204, 1);
  font-size: 16px;
  font-weight: 500;
  color: rgb(255, 255, 255);
  text-align: center;
  line-height: 36px;
  margin-right: 20px;
  cursor: pointer;
  letter-spacing: 4px;
}
.line1 {
  width: 4px;
  height: 28px;
  background: rgb(10, 96, 234);
  margin-right: 5px;
}
.line2 {
  width: 4px;
  height: 18px;
  background: rgb(10, 96, 234);
  margin-right: 5px;
}
.content {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  padding: 20px;
  margin-bottom: 20px;
}
.content-tip {
  border-radius: 5px;
  padding: 20px;
  background: rgba(243, 245, 247, 1);
}
.title-box {
  font-size: 14px;
  font-weight: 400;
}
.content-box {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 95, 46, 1) !important;
}
.flex {
  display: flex;
  align-items: center;
}
.announcement-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}
.title-name:hover {
  color: #409eff;
}
.title-name {
  color: #303133;
  font-weight: 600;
  cursor: pointer;
}
</style>